import React from "react";

export default function SUMIFS() {
  return <div>Excel_SUMIFS</div>;
}
